export enum RecognitionIndexStatusEnum {
  NotStarted = 'NOT_STARTED',
  InProgress = 'IN_PROGRESS', 
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}